var Instagram = function () {

  // Constants

  var token = 'IGQVJWLUZATVm42TGNld3ZAldktXaVhyNjIzbjdUZAHdOZA0p5MTFRQWdUNEVhSjJ2VGw0X0VUUVRZAejIwUTlra3lYN0wwQnM4akJwR1p3QVZAlZAVktTFVub1UzdlhrVGFLLVNkWkFuejBB';
  var graphBaseUrl = 'https://graph.instagram.com/';
  var mediaLimit = 12;
  var visibleClass = 'is-visible';

  // State

  var state = {
    mediaLoaded: 0,
    mediaToLoad: null,
    images: null
  }

  // Dom

  var $host    = $('[data-widget="instagram"]');
  var $loading = $('[data-loading-indicator]', $host);
  var $thumbs  = $('[data-instagram-thumbs]', $host);
  var $error   = $('[data-loading-error]',     $host);

  // Template

  function template (link, src) {
    return $(
      '<a class="thumb" href="' + link + '" target="_blank" rel="nofollow">' +
        '<img src="' + src + '">' +
      '</a>'
    );
  }

  // Helpers

  function limit (items) {
    var result = [];
    for (var i in items) if (i < mediaLimit) result.push(items[i]);
    return result;
  }

  function filterImages (items) {
    var result = [];
    for (var i in items) if (items[i].media_type === 'IMAGE') result.push(items[i]);
    return result;
  }

  function generateApiUrl (fields) {
    return graphBaseUrl + 'me/media?fields=' + fields.join(',') + '&access_token=' + token;
  }

  function preloadImage (item, callback) {
    var img = new Image();

    img.onload = callback;
    img.src    = item.media_url;
  }

  // API Call

  function getInstagramMedia () {
    var url = generateApiUrl(['permalink', 'media_url', 'media_type']);
    apiCall(url);
  }

  function apiCall (url) {
    $.ajax({
      url: url,
      success: success,
      error: error
    });
  }

  // DOM

  function reveal () {
    console.log('InstagramMedia::reveal');
    $host.find('.thumb').addClass(visibleClass);
  }

  function hideLoading () {
    console.log('InstagramMedia::hideLoading');
     $loading.hide();
  }

  function allImagesLoaded () {
    console.log('InstagramMedia::allImagesLoaded');
    state.images.map(function (item) {
       $thumbs.append(template(item.permalink, item.media_url))
    });
    hideLoading();
    reveal();
  }

  // Events

  function onImageLoad () {
    state.mediaLoaded++;
    if (state.mediaLoaded === state.mediaToLoad) {
      allImagesLoaded();
    }
  }

  function success (response) {
    var data = response.data;
    var images = filterImages(data);

    state.images = limit(images);
    state.mediaToLoad = state.images.length;
    state.images.map(function (item) {
     preloadImage(item, onImageLoad);
    });
  }

  function error (err) {
    hideLoading();
    TweenMax.to($error, 0.3, { autoAlpha: 1 });
    console.log(err, 'InstagramMedia::error')
  }

  // Init

  getInstagramMedia();

  console.log('testing');
}

module.exports = Instagram;